import { Box, styled, Typography } from '@mui/material';

export const NARROW_CONTAINER_QUERY = '@container (max-width: 700px)';

export const FieldWrapper = styled(Box)(({ theme }) => ({
  display: 'flex',
  width: '100%',
  gap: theme.spacing(6),
  paddingInlineEnd: '2px',
}));

export const Row = styled(FieldWrapper)(({ theme }) => ({
  marginBottom: '24px',
}));

export const CompactFormRow = styled(FieldWrapper)(({ theme }) => ({
  marginBottom: theme.spacing(3),
}));

export const ProfileTitle = styled(Typography)`
  color: ${({ theme }) => theme.custom?.brandNavy};
  font-size: 16px;
  font-weight: 650;
  line-height: 22.4px;
  letter-spacing: -0.08px;
`;

export const EmployeeCenterContainer = styled(Box)(({ theme }) => ({
  borderRadius: '16px',
  background: theme.background.white,
  padding: '6px 20px 18px',
  overflow: 'hidden',
  marginBottom: '16px',
  boxShadow: theme.custom?.cardShadow,
}));

export const EmployeeCenterTitleContainer = styled(Box)(({ theme }) => ({
  borderBottom: `1px solid ${theme.custom?.cardDivider}`,
  margin: '-6px -20px 16px',
  padding: '20px 20px 14px',
}));

interface ProfileTabContainerWithScrollProps {
  height?: string;
}

export const TabContainerAfterTitleWithScroll = styled(
  Box
)<ProfileTabContainerWithScrollProps>(() => ({
  width: '100%',
  height: '100vh',
  overflowY: 'auto',
  display: 'flex',
}));

export const ProfileTabTitleContainer = styled(Box)(({ theme }) => ({
  color: theme.colors.info.text,
  fontSize: '18px',
  fontStyle: 'normal',
  fontWeight: '600',
}));
